module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "aria-label": "1",
      "epub:type": "pagebreak",
      "id": "page1",
      "role": "doc-pagebreak"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "5",
      "epub:type": "pagebreak",
      "id": "page5",
      "role": "doc-pagebreak"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "_idContainer009"
    }
  }, [_c('p', {
    staticClass: "dedication"
  }, [_c('span', {
    staticClass: "Italic-Style"
  }, [_vm._v("For Marion & Russell Weis\n\t\t\t\t")])]), _vm._v(" "), _c('p', {
    staticClass: "dedication-space-before"
  }, [_c('span', {
    staticClass: "Italic-Style"
  }, [_vm._v("We have all heard stories\n\t\t\t\t\tof the problems caused by poor relationships with mothers- and fathers-in-law. I\n\t\t\t\t\thave had no such issues. Instead, I gained two loving parents who have treated\n\t\t\t\t\tme as a son for more than three decades. As I myself have transitioned into the\n\t\t\t\t\trole of father-in-law, their model as to how to give space, and give love—with\n\t\t\t\t\topen arms and no preconditions—continues to guide and inform me.")])])]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "7",
      "epub:type": "pagebreak",
      "id": "page7",
      "role": "doc-pagebreak"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d0baa94","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781504095785.vue
// module id = 72
// module chunks = 0